import { isRasterDatastoreType } from '@constant'

import { LAYER_TYPE } from '../layer'
import { ALayer } from './ALayer'
import { NbdsRasterLayer } from './NbdsRasterLayer'
import { NbdsVectorLayer } from './NbdsVectorLayer'

export function LayerDataCreate(type, layer) {
  const info = layer && layer.info
  if (
    info &&
    (isRasterDatastoreType(info) ||
      String(info.type || '').toLowerCase() === 'raster')
  ) {
    type = LAYER_TYPE.NBDS_RASTER_LAYER
    layer.data_type = LAYER_TYPE.NBDS_RASTER_LAYER
  }
  switch (type) {
    case LAYER_TYPE.NBDS_VECTO_LAYER:
      return new NbdsVectorLayer(layer)
    case LAYER_TYPE.NBDS_RASTER_LAYER:
      return new NbdsRasterLayer(layer)
    default:
      return new ALayer(layer)
  }
}
